import DgiLogo from "./dgi-logo";
export default DgiLogo;